import { Download } from "components/icons/generated";
import Button, { ButtonProps } from "ds/components/Button";

import useExportTraces from "./useExportTraces";

type ExportTracesButtonProps = {
  source: "pageHeader" | "phaseExecutionTime";
  size?: ButtonProps["size"];
};

const ExportTracesButton = ({ source, size = "medium" }: ExportTracesButtonProps) => {
  const { hasTraces, label, openDrawer } = useExportTraces(source);

  if (!hasTraces) {
    return null;
  }

  return (
    <Button variant="secondary" startIcon={Download} size={size} onPress={openDrawer}>
      {label}
    </Button>
  );
};

export default ExportTracesButton;
